import { functions, getDocument } from "@/utils/firebase";
import {
  BookingRequest,
  BookingConfirmation,
  UnconfirmedBookingAction
} from "./types";
import {
  buildCheckoutOrigin,
  completePaidBookingCheckout
} from "@/utils/checkout";

const createBookingCustomerFn = functions.httpsCallable(
  "createBookingCustomer"
);
const getBookingSummaryFn = functions.httpsCallable("getBookingSummary");
const cancelUnconfirmedCustomerBookingFn = functions.httpsCallable(
  "cancelUnconfirmedCustomerBooking"
);
const confirmUnconfirmedCustomerBookingFn = functions.httpsCallable(
  "confirmUnconfirmedCustomerBooking"
);

export const getBookingsAvailability = async (
  resourceId: string,
  serviceId: string
) => {
  const { data } = await getDocument(
    "availableBookings",
    `${resourceId}-${serviceId}`
  );
  return data ? data.bookings : data;
};

/** Create hold + optional Stripe session; does not redirect. */
export const createBookingCustomer = async (
  bookingRequest: BookingRequest
): Promise<BookingConfirmation> => {
  const response = await createBookingCustomerFn({
    booking: bookingRequest,
    checkoutOrigin: buildCheckoutOrigin()
  });
  return response.data as BookingConfirmation;
};

/**
 * @deprecated Prefer createBookingCustomer + proceedToCheckout for summary flow.
 * Kept for callers that still want create-and-redirect in one step.
 */
export const createBookingRequest = async (
  bookingRequest: BookingRequest
): Promise<BookingConfirmation> => {
  const confirmation = await createBookingCustomer(bookingRequest);

  if (confirmation.requiresPayment || confirmation.stripeCustomerId) {
    await completePaidBookingCheckout(confirmation, bookingRequest.storeId);
  }

  return confirmation;
};

export const cancelUnconfirmedBooking = async (
  action: UnconfirmedBookingAction
): Promise<void> => {
  await cancelUnconfirmedCustomerBookingFn(action);
};

export const confirmUnconfirmedBooking = async (
  action: UnconfirmedBookingAction
): Promise<{ bookingId: string }> => {
  const response = await confirmUnconfirmedCustomerBookingFn(action);
  return response.data;
};

export const getBookingSummary = async (opts: { bookingId: string }) => {
  const response = await getBookingSummaryFn(opts);
  return response.data;
};
